import { useAppContext } from '../../providers';
import { useAppDispatch } from '../../providers/AppProvider/AppProvider';
import { useSelectedResource, useSelectedLocation } from '..';
import * as types from '../../providers/AppProvider/types';

/**
 * Hook for getting / setting the selected plant with persistence
 * @returns {{selectedPlant: string, setSelectedPlant: (payload: string) => void}}
 */
export const useSelectedPlant = () => {
  const dispatch = useAppDispatch();
  const { selectedPlant } = useAppContext();
  const { setSelectedResource } = useSelectedResource();
  const { setSelectedLocation } = useSelectedLocation();

  /**
   * Set the selected plant and persist it
   * @param {string} payload - The plant identifier to select
   */
  const setSelectedPlant = (payload) => {
    dispatch({ type: types.SELECTED_PLANT, payload });
    localStorage.setItem(types.SELECTED_PLANT, payload);
    setSelectedResource(''); // reset selected resource when plant changes
    setSelectedLocation(''); // reset selected location when plant changes
  };

  return {
    selectedPlant,
    setSelectedPlant,
  };
};
